import React, { useState, useEffect } from 'react';
import SearchInput from '../../../../Constants/SearchInput';
import Post from '../../components/Post';
import { Link } from 'react-router-dom';
import DraftPostModal from '../../components/DraftPostModal';
import PlusLogo from '../../../../Assets/Images/plus-square.png';
import { useDispatch, useSelector } from 'react-redux';
import {
  deleteSinglePostAction,
  getAllPostAction,
  getAllPostSearchAction,
  updatePostAction,
} from '../../../../module/action/Post';
import { getBookVolumesAction } from '../../../../module/action/Book';
import DropDownIcon from '../../../../Assets/Icons/DropDownIcon';
import { Pagination } from 'antd';

const PAGE_SIZE = 10;

function AllPost() {
  const dispatch = useDispatch();
  const getAllPost = useSelector(e => e.Post.getAllSearchPost);
  const totalDocuments = useSelector(e => e.Post.totalDocuments);
  const bookData = useSelector(e => e.Book.bookData);
  const volumesData = useSelector(e => e.Book.volumesData);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editData, setEditData] = useState(false);
  const [bookId, setBookId] = useState('');
  const [volumeId, setVolumeId] = useState('');
  const [searchTextValue, setSearchTextValue] = useState('');
  const [pageNumber, setPageNumber] = useState(1);

  const showModal = a => {
    setIsModalOpen(true);
    setEditData(a);
  };
  const handleOk = () => {
    setIsModalOpen(false);
    setEditData(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
    setEditData(false);
  };
  useEffect(() => {
    dispatch(getAllPostAction('post'));
  }, []);
  useEffect(() => {
    setPageNumber(1); // Reset page number to 1 when filtering criteria changes
    dispatch(getAllPostSearchAction(searchTextValue, bookId, volumeId, 1, PAGE_SIZE));
  }, [searchTextValue, bookId, volumeId]);

  const updateStatus = (data, status, setPublishLoader) => {
    let obj = {
      ...data,
      status: status,
      book: data.book?.length ? data.book[0]._id : null,
      volume: data.volume?.length ? data.volume[0]._id : null,
      categories: data.categories.map(c => c._id),
    };
    delete obj.hadith_date_post;
    dispatch(
      updatePostAction(
        obj,
        obj._id,
        false,
        'post',
        handleOk,
        setPublishLoader,
        obj.book,
        obj.volume,
        obj.categories,

        searchTextValue,
        bookId,
        volumeId
      )
    );
  };

  const deletePost = (id, setDeleteLoader) => {
    dispatch(deleteSinglePostAction(id, 'post', handleOk, setDeleteLoader, searchTextValue, bookId, volumeId));
  };

  useEffect(() => {
    if (bookId) {
      dispatch(getBookVolumesAction(bookId));
    }
  }, [bookId]);

  const changeFunction = ev => {
    setSearchTextValue(ev.target.value);
  };

  return (
    <div className="AllPost  my-12 px-8">
      {/* <Logo /> */}
      <div className="header md:flex-row flex-col md:justify-between justify-center items-center flex ">
        <div className="flex align-middle items-center mb-2 md:mb-0">
          <h2 className="text-[32px] font-extrabold ">All Posts</h2>
        </div>
        <Link to="/new-post">
          <button className="text-base flex justify-center items-center bg-gray-100 h-[48px] w-[218px]  rounded-xl  font-[Poppins-Bold] transition ease-in-out delay-150 hover:-translate-y-0.5 hover:scale-105">
            <img src={PlusLogo} className="mr-2" />
            New Post
          </button>
        </Link>
      </div>
      <div className="filterPosts flex justify-between w-full">
        <SearchInput
          searchText={false}
          width="w-[calc(50%-15px)]"
          inputHeight="h-[48px]"
          placeHolder="Write any word of post, Post number or Post reference "
          changeFunction={changeFunction}
        />
        <div className="flex justify-between  w-[calc(50%-15px)] items-end">
          <label className="w-[calc(50%-12.16px)] h-[48px] relative flex items-center">
            <DropDownIcon className="pointer-events-none absolute z-[1] right-[22px]" />

            <select
              className="rounded-xl border-[1px] border-[#dde4de] w-full h-full  px-6 outline-none after:mr-[8px] selectInput font-[Poppins-SemiBold]"
              onChange={ev => {
                setBookId(ev.target.value);
              }}>
              <option value={''} className="hidden">
                Choose book
              </option>
              {bookData &&
                bookData.map(
                  (a, i) =>
                    a.bookName && (
                      <option key={i} value={a._id}>
                        {a.bookName}
                      </option>
                    )
                )}
            </select>
          </label>
          <label className="w-[calc(50%-15px)] h-[48px] relative flex items-center">
            <DropDownIcon className="pointer-events-none absolute z-[1] right-[22px]" />
            <select
              disabled={!volumesData}
              className="rounded-xl border-[1px] border-[#dde4de] w-full h-full  px-6 outline-none selectInput font-[Poppins-SemiBold]"
              onChange={ev => {
                setVolumeId(ev.target.value);
              }}>
              <option value="">All volume</option>
              {volumesData &&
                volumesData.map(
                  (a, i) =>
                    a.volume_name && (
                      <option key={i} value={a._id}>
                        {a.volume_name}
                      </option>
                    )
                )}
            </select>
          </label>
        </div>
      </div>
      <div className="postLists py-6 flex flex-wrap justify-between">
        {getAllPost &&
          getAllPost.map((a, i) => {
            return (
              <Post
                showModal={showModal}
                data={a}
                index={i}
                statusFunction={updateStatus}
                deleteFunction={deletePost}
              />
            );
          })}
      </div>
      <div className="w-full flex justify-center items-center">
        <Pagination
          showSizeChanger={false}
          onChange={pageNumber => {
            setPageNumber(pageNumber);
            dispatch(getAllPostSearchAction(searchTextValue, bookId, volumeId, pageNumber, PAGE_SIZE));
          }}
          current={pageNumber}
          pageSize={PAGE_SIZE}
          total={totalDocuments}
        />
      </div>
      <DraftPostModal
        isModalOpen={isModalOpen}
        handleOk={handleOk}
        handleCancel={handleCancel}
        data={editData}
        statusFunction={updateStatus}
        deleteFunction={deletePost}
        status={'post'}
        actionButtons={true}
      />
    </div>
  );
}

export default AllPost;
